import { Link } from "react-router-dom";
import { updates, getComic } from "../../../mocks/manga";

export default function Updates() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16" aria-labelledby="updates-heading">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
        <div>
          <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
            <div>
              <h2 id="updates-heading" className="font-display text-2xl text-foreground-950 md:text-3xl">
                最近更新
              </h2>
              <p className="mt-1 text-sm text-foreground-500">热门漫画章节实时更新，追更不错过</p>
            </div>
            <Link to="/library" className="flex items-center gap-1 whitespace-nowrap rounded-full bg-background-100 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700">
              全部更新 <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
            </Link>
          </div>
          <div className="overflow-hidden rounded-2xl border border-background-200/70 bg-background-50">
            {updates.map((u, idx) => {
              const comic = getComic(u.comicId);
              if (!comic) return null;
              return (
                <Link
                  key={u.comicId}
                  to={`/detail/${comic.id}`}
                  className={`flex items-center gap-4 p-3.5 transition-colors hover:bg-background-100 ${idx !== 0 ? "border-t border-background-200/70" : ""}`}
                >
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-xs font-bold ${
                    idx < 3 ? "bg-accent-500 text-foreground-950" : "bg-background-200 text-foreground-600"
                  }`}>
                    {idx + 1}
                  </span>
                  <img src={comic.cover} alt={`${comic.title} 封面`} className="h-14 w-10 shrink-0 rounded-md object-cover object-top" />
                  <div className="min-w-0 flex-1">
                    <p className="truncate font-medium text-foreground-950">{comic.title}</p>
                    <p className="mt-0.5 truncate text-xs text-foreground-500">{u.chapter}</p>
                  </div>
                  <span className="whitespace-nowrap text-xs text-foreground-400">{u.time}</span>
                </Link>
              );
            })}
          </div>
        </div>

        <div>
          <div className="mb-6">
            <h2 className="font-display text-2xl text-foreground-950 md:text-3xl">追更提醒</h2>
            <p className="mt-1 text-sm text-foreground-500">收藏作品后，更新进度自动同步到你的书架</p>
          </div>
          <div className="space-y-4">
            {getComic("spring-etude") && (
              <MiniCard
                comicId="spring-etude"
                title="《春日练习曲》本周大更"
                desc="第36话「同频」已上线，春日二重奏迎来关键转折，快来接续阅读！"
                accent
              />
            )}
            {getComic("paper-wonderland") && (
              <MiniCard
                comicId="paper-wonderland"
                title="《纸境奇缘》新篇章开启"
                desc="第29话「折叠之城」解锁全新地图，折纸少女的冒险再出发。"
              />
            )}
            {getComic("moonlit-street") && (
              <MiniCard
                comicId="moonlit-street"
                title="《月隐街拾遗》更新"
                desc="第82话「旧日的钟」温情上线，老街又迎来了新的访客。"
              />
            )}
          </div>
          <div className="mt-6 rounded-2xl border border-accent-300/60 bg-accent-100/70 p-5">
            <p className="flex items-center gap-2 font-display text-lg text-foreground-950">
              <i className="ri-bookmark-3-fill text-accent-600" aria-hidden="true"></i>
              还没有书架？
            </p>
            <p className="mt-1 text-sm leading-relaxed text-foreground-600">
              把喜欢的作品加入收藏，阅读进度自动保存，按标签筛选，追更找漫更省心。去「漫画大全」逛逛吧。
            </p>
            <Link to="/library" className="mt-3 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-500 px-5 py-2 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-600">
              开始收藏 <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

function MiniCard({ comicId, title, desc, accent }: { comicId: string; title: string; desc: string; accent?: boolean }) {
  const comic = getComic(comicId);
  if (!comic) return null;
  return (
    <Link to={`/detail/${comic.id}`} className={`flex items-start gap-4 rounded-2xl border border-background-200/70 p-4 transition-transform hover:-translate-y-0.5 ${
      accent ? "bg-background-50" : "bg-background-100"
    }`}>
      <img src={comic.cover} alt={`${comic.title} 封面`} className="h-20 w-14 shrink-0 rounded-lg object-cover object-top" />
      <div className="min-w-0">
        <h3 className="font-medium text-foreground-950">{title}</h3>
        <p className="mt-1 text-sm leading-relaxed text-foreground-600">{desc}</p>
        <p className="mt-2 text-xs text-foreground-400">{comic.latestChapter}</p>
      </div>
    </Link>
  );
}